import React, { useState } from "react";

function getCookie(name) {
  let cookieValue = null;
  if (document.cookie && document.cookie !== "") {
    const cookies = document.cookie.split(";");
    for (let cookie of cookies) {
      cookie = cookie.trim();
      if (cookie.startsWith(name + "=")) {
        cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
        break;
      }
    }
  }
  return cookieValue;
}

export default function CreateGroup({ onGroupCreated, onCancel }) {
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleCreateGroup = () => {
    if (!name.trim()) {
      setError("Group name is required.");
      return;
    }
    setLoading(true);
    setError("");
    const csrftoken = getCookie("csrftoken");

    fetch("/groups/api/create/", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-CSRFToken": csrftoken,
      },
      body: JSON.stringify({ name, description }),
    })
      .then((res) => {
        if (!res.ok) throw new Error("Failed to create group");
        return res.json();
      })
      .then((data) => {
        onGroupCreated(data.group);
        setName("");
        setDescription("");
      })
      .catch((err) => setError(err.message || "Error creating group"))
      .finally(() => setLoading(false));
  };

  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      onCancel();
    }
  };

  return (
    <div 
      className="user-settings-modal-overlay"
      onClick={handleBackdropClick}
      style={{ zIndex: 5000 }}
    >
      <div 
        className="user-settings-modal-content"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="user-settings-modal-header">
          <h2>Create New Group</h2>
          <button 
            className="user-settings-modal-close"
            onClick={onCancel}
            aria-label="Close"
          >
            ×
          </button>
        </div>

        <div className="user-settings-modal-body">
          <form autoComplete="off" onSubmit={(e) => e.preventDefault()}>
            {/* Hidden password field to trick browsers */}
            <input type="password" style={{ display: 'none' }} autoComplete="new-password" />

            <div className="form-group">
              <label htmlFor="groupName">Group Name</label>
              <input
                id="groupName"
                type="text"
                placeholder="Enter group name"
                value={name}
                onChange={(e) => setName(e.target.value)}
                autoComplete="off"
                spellCheck="false"
              />
            </div>

            <div className="form-group">
              <label htmlFor="groupDescription">Description</label>
              <textarea
                id="groupDescription"
                placeholder="Describe your group (optional)"
                value={description}
                onChange={(e) => setDescription(e.target.value)}
                rows={3}
              />
            </div>

            {error && (
              <div className="error-message-small">{error}</div>
            )}
          </form>

          <div className="user-settings-modal-actions">
            <button 
              className="btn-secondary" 
              onClick={onCancel}
              disabled={loading}
            >
              Cancel
            </button>
            <button 
              className="btn-primary" 
              onClick={handleCreateGroup}
              disabled={loading}
            >
              {loading ? 'Creating...' : 'Create Group'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
